import { render, staticRenderFns } from "./AIMode.vue?vue&type=template&id=37b5ad32&scoped=true"
import script from "./AIMode.vue?vue&type=script&lang=js"
export * from "./AIMode.vue?vue&type=script&lang=js"
import style0 from "./AIMode.vue?vue&type=style&index=0&id=37b5ad32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b5ad32",
  null
  
)

export default component.exports